import React, { useState } from 'react';
import styled from 'styled-components';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
  Button
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { breakpoint } from './assests/style';
import { Aspects } from './Aspects';

export const StyledAccordion = styled(Accordion)`
  @media only screen and (max-width: ${breakpoint.medium}px) {
    margin-bottom: 1rem;
    margin-right: 0;
  }
`;

const sidebarStyle = { backgroundColor: '#edeeef' };

const AspectsAccordion = ({ aspects,handleAspectsChange }) => {
  const [expanded, setExpanded] = useState('panel1');

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <StyledAccordion
      style={sidebarStyle}
      expanded={expanded === 'panel1'}
      onChange={handleChange('panel1')}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel1bh-content"
        id="panel1bh-header"
      >
        <Typography variant="h6">Filters</Typography>
	<Button onClick={() => handleAspectsChange({})}>Clear Filters</Button>
      </AccordionSummary>
      <AccordionDetails>
        <Aspects aspects={aspects} handleAspectsChange={handleAspectsChange}/>
      </AccordionDetails>
    </StyledAccordion>
  );
};
export { AspectsAccordion };
